import RequestReferenceTypeModel from "../models/RequestReferenceTypeModel";
import { IHttpRequestService } from "./HttpRequestService";

export interface IRequesterSourceTypeService {
    GetCurrent(): Promise<RequestReferenceTypeModel[]>;
}

export class RequesterSourceTypeService implements IRequesterSourceTypeService {
    constructor(private httpRequestService: IHttpRequestService) {}

    public async GetCurrent(): Promise<RequestReferenceTypeModel[]> {
        try {
            const { data } = await this.httpRequestService.Get<RequestReferenceTypeModel[]>('/api/v1/RequesterSourceType');
            return data as RequestReferenceTypeModel[];
        } catch (e) {
            this.httpRequestService.HandleError(e);
        }
        return [];
    }
}
